import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-41b4e1a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", { class: "m-5" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center" }, "NFT Gallery")
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-center fs-3 px-5 my-5" }, " Welcome to the Memphis Lions Club MetaGallery! In the future you will be able to launch your own NFT collection and trade your NFTs, but in the meantime you can view specially curated NFTs from the MLC and our partner collections. ", -1))
const _hoisted_3 = { class: "d-flex flex-wrap align-items-center justify-content-evenly my-5" }
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "cta-header" }, "Mint a Lion", -1))
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "mt-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "cta-header" }, "Metagallery", -1))
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "my-5" }
const _hoisted_11 = { class: "my-5" }
const _hoisted_12 = { class: "d-flex justify-content-center flex-wrap" }
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = ["src"]
const _hoisted_17 = { class: "d-flex justify-content-center flex-wrap" }
const _hoisted_18 = ["src"]
const _hoisted_19 = ["src"]
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "d-flex align-items-center justify-content-evenly w-100 flex-wrap my-5" }
const _hoisted_22 = { class: "d-flex justify-content-center flex-wrap" }
const _hoisted_23 = ["src"]

import MintModal from '@/components/modals/MintModal.vue';
import MetaGalleryModal from '@/components/modals/MetaGalleryModal.vue';
import { ref } from 'vue';
import PageFooter from '@/components/PageFooter.vue';
import CTAButton from '@/components/buttons/CTAButton.vue';
import BackButton from '@/components/buttons/BackButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'GalleryPage',
  setup(__props) {

const showMintModal = ref(false);
const showMetaGalleryModal = ref(false);

const onMintLionButtonClick = () => {
  window.open('https://mint.memphislionsclub.com', '_blank');
};

return (_ctx: any,_cache: any) => {
  const _component_b_link = _resolveComponent("b-link")!
  const _component_b_container = _resolveComponent("b-container")!

  return (_openBlock(), _createBlock(_component_b_container, { class: "container-md" }, {
    default: _withCtx(() => [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (showMintModal.value)
            ? (_openBlock(), _createBlock(MintModal, {
                key: 0,
                onClose: _cache[0] || (_cache[0] = ($event: any) => (showMintModal.value = false))
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(BackButton),
      _hoisted_1,
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(CTAButton, { onClick: onMintLionButtonClick }, {
            header: _withCtx(() => [
              _hoisted_5
            ]),
            image: _withCtx(() => [
              _createElementVNode("img", {
                class: "cta-image",
                src: require('@/assets/mlc-logo-fill.png'),
                alt: "MLC"
              }, null, 8, _hoisted_6)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_b_link, {
            href: "https://metagallery.memphislionsclub.com",
            target: "_blank"
          }, {
            default: _withCtx(() => [
              _createVNode(CTAButton, null, {
                header: _withCtx(() => [
                  _hoisted_8
                ]),
                image: _withCtx(() => [
                  _createElementVNode("img", {
                    class: "cta-image",
                    src: require('@/assets/mlc-logo-fill.png'),
                    alt: "MLC"
                  }, null, 8, _hoisted_9)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("img", {
              class: "img-thumbnail w-100 m-3 lion-gif",
              src: require('@/assets/lions.gif'),
              alt: "NFT"
            }, null, 8, _hoisted_13),
            _createElementVNode("img", {
              class: "img-thumbnail w-25 m-3 hidden-sm",
              src: require('@/assets/lion-001.png'),
              alt: "NFT"
            }, null, 8, _hoisted_14),
            _createElementVNode("img", {
              class: "img-thumbnail w-25 m-3 hidden-sm",
              src: require('@/assets/lion-002.png'),
              alt: "NFT"
            }, null, 8, _hoisted_15),
            _createElementVNode("img", {
              class: "img-thumbnail w-25 m-3 hidden-sm",
              src: require('@/assets/lion-003.png'),
              alt: "NFT"
            }, null, 8, _hoisted_16)
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("img", {
              class: "img-thumbnail w-25 m-3 hidden-sm",
              src: require('@/assets/lion-004.png'),
              alt: "NFT"
            }, null, 8, _hoisted_18),
            _createElementVNode("img", {
              class: "img-thumbnail w-25 m-3 hidden-sm",
              src: require('@/assets/lion-005.png'),
              alt: "NFT"
            }, null, 8, _hoisted_19),
            _createElementVNode("img", {
              class: "img-thumbnail w-25 m-3 hidden-sm",
              src: require('@/assets/lion-006.png'),
              alt: "NFT"
            }, null, 8, _hoisted_20)
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_b_link, {
              href: "https://ftx.us/nfts",
              target: "_blank",
              rel: "noopener noreferrer"
            }, {
              default: _withCtx(() => [
                _createElementVNode("img", {
                  class: "icon-image",
                  src: require('@/assets/ftx-on-dark.png'),
                  alt: "FTX"
                }, null, 8, _hoisted_23)
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _createVNode(PageFooter)
    ]),
    _: 1
  }))
}
}

})